// Product details tabs (Beschreibung / Versand / Widerrufsrecht & Rückgaben).
// WAI-ARIA tabs: click or arrow keys switch panels; the new panel fades in.
class SProductTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = this.tabs.map((tab) => this.querySelector(`#${tab.getAttribute('aria-controls')}`));
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.select(index));
      tab.addEventListener('keydown', (event) => {
        let next = null;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (next === null) return;
        event.preventDefault();
        this.select(next);
        this.tabs[next].focus();
      });
    });
  }

  select(index) {
    this.tabs.forEach((tab, i) => {
      const active = i === index;
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.tabIndex = active ? 0 : -1;
      const panel = this.panels[i];
      if (!panel) return;
      panel.hidden = !active;
      if (active && !this.reducedMotion.matches) {
        panel.animate([{ opacity: 0, transform: 'translateY(6px)' }, { opacity: 1, transform: 'none' }], {
          duration: 260,
          easing: 'ease-out',
        });
      }
    });
  }
}

if (!customElements.get('s-product-tabs')) customElements.define('s-product-tabs', SProductTabs);
